// En tu archivo principal de navegación (ej: App.tsx o un RootNavigator.tsx)

import React, { FC, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../store/hooks'; // Asume esta ruta
import { validateLoginAction } from '../controller/authController'; // Asume esta ruta
import MainNavigationRoutes from './MainNavigationRoute'; // Tu DrawerNavigator
import LoginScreen from './Authentication/LoginScreen'; // Tu nueva pantalla de Login

const RootNavigator: FC = () => {
  const dispatch = useAppDispatch();
  const auth = useAppSelector(state => state.auth)

  useEffect(() => {
    // 2. Dispara la validación del token al iniciar (para manejar el "splash screen")
    dispatch(validateLoginAction());
  }, [dispatch]);

  if (auth.isLoggedIn) {
    // 🛑 Si el usuario tiene token válido, muestra la navegación principal.
    return <MainNavigationRoutes />;
  } else {
    // 🛑 Si no está logueado, muestra la pantalla de Login.
    return <LoginScreen />;
  }
};

export default RootNavigator;